import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { fetchCrearEmpresaColaboradora } from '../../../peticiones_API/PeticionesEmpresasColaboradoras';
import ErrorForm from '../eventos/avisos/Alerta';
import { handleChangeErrors, handleSubmitErrorsEmpresas, todosDatosCorrectos } from '../../validacion/ValidationFormEmpresa';
import { DatosCorrectosEmpresa, ServerNoCreoEmpresa, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import { ChromePicker } from 'react-color';
import { ToastContainer, toast } from "react-toastify";
import useFormPersistence from '../../../hooks/useFormPersistence';
import { FormControlLabel, Switch } from '@mui/material';

const FormCrearEmpresaColaboradora = () => {

const initialFormState = {
        nombre: '',
        vacaciones: false,
    };

const [formData, setFormData, clearFormDraft] = useFormPersistence(
    'crear_empresa_colaboradora',
    initialFormState
);

    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
        color: "Debes seleccionar un color",
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: null,
        color: null,
    });

    let [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);
    const [mostrarColorPicker, setMostrarColorPicker] = useState(false);

    const [errorEnviarForm, setErrorEnviarForm] = useState({
        empresaDuplicada: null,
        refDuplicado: null
    });

    const handleSubmit = async (event) => {
        event.preventDefault();
        setEstadosActualizados(false);
        handleSubmitErrorsEmpresas(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
    };

    useEffect (() => {
        if (estadosActualizados) {
            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setErrorEnviarForm(prevFormData => ({ ...prevFormData, empresaDuplicada: false }));
                    setFormCompletado(true);
                    try {
                        const dataToSend = { ...formData };
                        await fetchCrearEmpresaColaboradora(dataToSend);
                    } catch (error) {
                        if (error?.response?.data?.error === 'REGISTRO_DUPLICADO') {
                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, empresaDuplicada: true }));
                        }
                        setFormCompletado(false);
                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
            })();
        }
    }, [estadosActualizados, formData, estadoCampoReque])

    const handleChange = (event) => {
        const { name, value, type, files } = event.target
        let newValue = type === 'file' ? files[0] : value;
        setFormData(prevFormData => ({ ...prevFormData, [name]: newValue }));
        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }
    }

    const handleColorChange = (color) => {
        setFormData(prev => ({ ...prev, color: color.hex }));
        handleChangeErrors('color', color.hex, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
    };

    return (
        <>
            <Form>
                <CabeceraForm>
                    <Titulo texto="AGREGA UNA EMPRESA COLABORADORA" />
                </CabeceraForm>

                <Container>
                    <ToastContainer/>
                    <Col>
                        <Row md={5} style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Form.Group className="mb-12" style={{ width: '480px' }}>
                                <TituloCategoria>Nombre <span>*</span></TituloCategoria>
                                <Form.Control type='name' name='nombre' className="py-3" value={formData.nombre || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria>Color <span>*</span></TituloCategoria>
                                <div style={{ position: 'relative' }}>
                                    <div
                                        style={{
                                            padding: '11px',
                                            background: '#fff',
                                            borderRadius: '4px',
                                            border: '1px solid #ced4da',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}
                                        onClick={() => setMostrarColorPicker(!mostrarColorPicker)}
                                    >
                                        <div style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '4px',
                                            background: formData.color || '#ffffff',
                                            border: '1px solid #ccc'
                                        }} />
                                        <span>{formData.color || 'Seleccionar color'}</span>
                                    </div>
                                    {mostrarColorPicker && (
                                        <div style={{ position: 'absolute', zIndex: 2, marginTop: '5px' }}>
                                            <div
                                                style={{
                                                    position: 'fixed',
                                                    top: '0px',
                                                    right: '0px',
                                                    bottom: '0px',
                                                    left: '0px'
                                                }}
                                                onClick={() => setMostrarColorPicker(false)}
                                            />
                                            <ChromePicker
                                                color={formData.color || '#ffffff'}
                                                onChange={handleColorChange}
                                            />
                                        </div>
                                    )}
                                </div>
                                <ErrorForm mensaje={camposRequeridos.color} estadoAlerta={estadoCampoReque.color} />
                            </Form.Group>

                            <Form.Group className="mb-12" style={{ marginTop: '20px' }}>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={formData.vacaciones || false}
                                            onChange={(e) => setFormData(prev => ({ ...prev, vacaciones: e.target.checked }))}
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': { color: 'rgba(0, 60, 102, 0.9)' },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: 'rgba(0, 60, 102, 0.5)' }
                                            }}
                                        />
                                    }
                                    label={<span style={{ fontSize: '15.6px', fontWeight: 'bold', fontFamily: 'Open Sans', color: '#4a4a4a' }}>Vacaciones</span>}
                                />
                                <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '-4px', marginLeft: '12px' }}>
                                    Las personas de esta empresa tendrán acceso a la sección de vacaciones
                                </div>
                            </Form.Group>

                        </Row>
                        <Row>
                            <ContenedorBotones style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
                                <Boton
                                    bonificados="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"
                                >
                                    Agregar Empresa Colaboradora
                                </Boton>
                                <Boton
                                    grande="true"
                                    to="/gestionpersonas/empresas"
                                >
                                    Cancelar
                                </Boton>
                            </ContenedorBotones>
                        </Row>
                    </Col>
                </Container>
            </Form>
            <DatosCorrectosEmpresa envioActivado={formCompletado} />
            <DatosIncorrectos envioActivado={formCompletado} duplicado={errorEnviarForm.empresaDuplicada} />
            <ServerNoCreoEmpresa envioActivado={errorEnviarForm.empresaDuplicada} />
        </>
     );
}

const CabeceraForm = styled.div`
    margin: 2% 0% 2% 35%;
`

const ContenedorBotones = styled.div`
    margin-top: 30%;
`

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }
`

export default FormCrearEmpresaColaboradora;
